import React, { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { isPublicRoute } from 'routes/PublicRoutes/guards';

import PublicApp from 'WealthTechApp/PublicApp';
import PrivateApp from 'WealthTechApp/PrivateApp';

import CustomSpinner from 'components/shared/CustomSpinner';

import { useStylesReady } from 'hooks';

const WealthTechApp = () => {
  const { pathname } = useLocation();
  const isPublic = useMemo(() => isPublicRoute(pathname), [pathname]);

  const stylesReady = useStylesReady();

  if (!stylesReady) {
    return <CustomSpinner />;
  }

  return isPublic ? <PublicApp /> : <PrivateApp />;
};

export default WealthTechApp;
